<template>
    <q-dialog
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
    >
        <q-card 
            :bordered="$q.dark.isActive"
            :square="$q.dark.isActive"
            :flat="$q.dark.isActive"
            style="min-width: 40vw;"
        >
            <q-toolbar :class="{'bg-primary text-white': !$q.dark.isActive}">
                <q-toolbar-title>
                    <q-icon name="mdi-swap-horizontal" /> Swap Location
                </q-toolbar-title>
                <q-btn
                    dense
                    round
                    flat
                    icon="mdi-refresh"
                    @click="fetchAltContacts()"
                />
                <q-btn
                    dense
                    round
                    flat
                    icon="mdi-close"
                    @click="$emit('update:modelValue', false)"
                />
            </q-toolbar>

            <q-separator />

            <q-card-section>
                Swap the work order's location within a customer's organization.
            </q-card-section>

            <q-separator />

            <q-card-section class="q-pa-none">
                <q-list :separator="$q.dark.isActive">
                    <q-item
                        v-ripple
                        tag="label"
                        :class="{'bg-dark-page': $q.dark.isActive}"
                        :key="customer.id"
                    >
                        <q-item-section avatar>
                            <q-radio 
                                @update:model-value="updateContact(customer.contact)"
                                :model-value="selectedContact.id"
                                :val="customer.contact.id"
                            />
                        </q-item-section>
                        <q-item-section>
                            <q-item-label>
                                {{ customer.contact.org_name }}
                            </q-item-label>
                            <q-item-label caption>
                                <q-badge>
                                    Main Customer
                                </q-badge>
                                <!-- ID: {{ customer.contact.id }} - Value: {{ subCustomerId }} -->
                            </q-item-label>
                        </q-item-section>
                    </q-item>
                    <q-item
                        v-for="(altContact) in customer.alt_contact"
                        v-ripple
                        tag="label"
                        :class="{'bg-dark-page': $q.dark.isActive}"
                        :key="altContact.id"
                    >
                        <q-item-section avatar>
                            <q-radio 
                                @update:model-value="updateContact(altContact.contact)"
                                :model-value="selectedContact.id"
                                :val="altContact.contact.id"
                            />
                        </q-item-section>
                        <q-item-section>
                            <q-item-label>
                                {{ altContact.contact.org_name }}
                            </q-item-label>
                            <q-item-label caption>
                                <q-badge class="bg-deep-purple">
                                    Alternate Location
                                </q-badge>
                            </q-item-label>
                        </q-item-section>
                    </q-item>
                </q-list>

                <div v-if="customer.alt_contact.length == 0" class="q-pa-xl text-center">
                    <q-icon name="mdi-alert" color="grey-5" size="lg" />
                    <div class="text-h6 text-grey-5">
                        No Alternate Locations Found!
                        <!-- TODO: Link to create one -->
                    </div>
                </div>

                <q-inner-loading
                    :showing="loading"
                    label="Loading Sub-Customers..."
                />
            </q-card-section>

            <q-separator />

            <q-card-actions>
                <!-- Submit and reset buttons -->
                <q-btn
                    :disable="loading || selectedContact == contact"
                    color="positive"
                    label="Submit"
                    @click="submitContact"
                />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
// This needs to modify the contact_id of a work order
// If the main customer is selected, then the contact_id is the customer's contact_id
export default {
    name: 'SwapLocation',
    emits: [
        'update:modelValue',
        'update:contact'
    ],
    props: {
        customerId: {
            type: Number,
            default: () => null
        },
        contact: {
            type: Object,
            default: () => null
        },
        modelValue: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            loading: false,
            selectedContact: this.contact,
            // We also need to consider the main customer.
            customer: {
                contact: {
                    org_name: '',
                },
                alt_contact: [],
            },
        }
    },
    methods: {
        async fetchAltContacts() {
            if (this.customerId < 1) return;

            this.loading = true;

            this.axios.get(`/api/v1/customer/${this.customerId}/alt-locations`)
                .then(({ data }) => {
                    this.customer = data.data;
                })
                .catch((error) => {
                    console.error(error);

                    this.$q.notify({
                        color: 'negative',
                        message: 'Failed to load sub-customers!',
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        updateContact(contact) {
            this.selectedContact = contact;
        },
        submitContact() {
            this.$emit('update:contact', this.selectedContact);
        }
    },
    watch: {
        modelValue(to) {
            if (to) {
                this.fetchAltContacts();

                this.selectedContact = this.contact;
                return;
            }
            // Cleanup
            this.selectedContact = null;
            this.customer = {
                contact: {
                    org_name: '',
                },
                alt_contact: [],
            };
        },
        customerId: {
            immediate: true,
            handler() {
                this.fetchAltContacts();

                this.selectedContact = this.contact;
            }
        }
    },
}
</script>